const prefix = 'cvf-admin/paymentMethods/';

export const GET_PAYMENT_METHODS = `${prefix}GET_PAYMENT_METHODS`;
export const GET_PAYMENT_METHODS_SUCCESS = `${prefix}GET_PAYMENT_METHODS_SUCCESS`;
export const GET_PAYMENT_METHODS_ERROR = `${prefix}GET_PAYMENT_METHODS_ERROR`;

export const ADD_PAYMENT_METHOD = `${prefix}ADD_PAYMENT_METHOD`;
export const ADD_PAYMENT_METHOD_SUCCESS = `${prefix}ADD_PAYMENT_METHOD_SUCCESS`;
export const ADD_PAYMENT_METHOD_ERROR = `${prefix}ADD_PAYMENT_METHOD_ERROR`;

export const DELETE_PAYMENT_METHOD = `${prefix}DELETE_PAYMENT_METHOD`;
export const DELETE_PAYMENT_METHOD_SUCCESS = `${prefix}DELETE_PAYMENT_METHOD_SUCCESS`;
export const DELETE_PAYMENT_METHOD_ERROR = `${prefix}DELETE_PAYMENT_METHOD_ERROR`;
